import { APP_LS_NAMESPACE_ID, APPLICANT } from "src/constants";
import { DEPOSIT_ACCOUNTS, CONSUMER_ACCOUNT, BUSINESS_ACCOUNT } from "src/features/LoansHome/Products/constants";
import {
    SMARTMATCH_TYPE_LOAN_OFFICER,
    SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER, STATUS_APPLICATION_STARTED, STATUS_SUBMITTED,
    STATUS_APPROVED, STATUS_APPROVAL, STATUS_APPROVED_NOT_ACCEPTED,
    STATUS_BOOKING_COMPLETE, STATUS_CLEAR_TO_CLOSE_COMPLETED, STATUS_CLOSED,
    STATUS_CLOSED_FOR_INCOMPLETENESS, STATUS_CREDIT_APPROVAL, STATUS_DECLINED,
    STATUS_DENIAL_UNDER_REVIEW, STATUS_DOCS_IN_EPRINT, STATUS_DOCUMENTS_SIGNED,
    STATUS_RECOMMENDED_APPROVE,
    STATUS_RECOMMENDED_DECLINE, STATUS_UNDER_REVIEW, STATUS_UNTOUCHED,
    STATUS_WITHDRAW,
    STATUS_ACCOUNT_OPENED,
    STATUS_PRE_QUALIFIED,
    STATUS_PENDING,
    STATUS_BOOKED_TO_CORE
} from "src/services/constants";
import { USER_ONBOARD_ADMIN } from "src/services/constants/accounts";


const stageStartedDeposit = {
    name: STATUS_APPLICATION_STARTED,
    display_name: STATUS_APPLICATION_STARTED,
    order_id: 1,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                }
            ]
        },
    ]
}

const stageUnderReviewDeposit = {
    name: STATUS_UNDER_REVIEW,
    display_name: STATUS_RECOMMENDED_DECLINE,
    order_id: 1,
    children: [
        {
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                }
            ]
        },
    ]
}


const stageApprovalDeposit = {
    name: STATUS_APPROVAL,
    display_name: STATUS_APPROVAL,
    order_id: 1,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                }
            ]
        },
    ]
}

const stageSubmittedDeposit = {
    name: STATUS_SUBMITTED,
    display_name: STATUS_SUBMITTED,
    order_id: 2,
    children: [
        {
            stages: [
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_RECOMMENDED_DECLINE,
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
            ]
        },
    ]
}

const stageApprovedDeposit = {
    name: STATUS_APPROVED,
    display_name: STATUS_APPROVED,
    order_id: 3,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_PENDING,
                    display_name: STATUS_PENDING,
                },
                {
                    name: STATUS_UNDER_REVIEW,
                    display_name: STATUS_UNDER_REVIEW,
                },
                {
                    name: STATUS_DOCUMENTS_SIGNED,
                    display_name: STATUS_DOCUMENTS_SIGNED,
                },
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                },
                {
                    name: STATUS_BOOKED_TO_CORE,
                    display_name: STATUS_BOOKED_TO_CORE,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
            ]
        },
    ]
}

const stageDocSignDeposit = {
    name: STATUS_DOCUMENTS_SIGNED,
    display_name: STATUS_DOCUMENTS_SIGNED,
    order_id: 4,
    children: []
}

const stageClosedDeposit = {
    name: STATUS_CLOSED,
    display_name: STATUS_CLOSED,
    order_id: 5,
    children: []
}

const stageDeclinedDeposit = {
    name: STATUS_DECLINED,
    display_name: STATUS_DECLINED,
    order_id: 6,
    children: []
}

const stageDenialUnderReviewDeposit = {
    name: STATUS_DENIAL_UNDER_REVIEW,
    display_name: STATUS_DENIAL_UNDER_REVIEW,
    order_id: 6,
    children: [
        {
            stages: [
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                },
            ]
        }
    ]
}

const stageRecommendedDeclineDeposit = {
    name: STATUS_UNDER_REVIEW,
    display_name: STATUS_RECOMMENDED_DECLINE,
    order_id: 6,
    children: [
        {
            stages: [
                {
                    name: STATUS_PRE_QUALIFIED,
                    display_name: STATUS_RECOMMENDED_APPROVE,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
            ]
        }
    ]
}

const stageRecommendedApprovedDeposit = {
    name: STATUS_PRE_QUALIFIED,
    display_name: STATUS_RECOMMENDED_APPROVE,
    order_id: 6,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
            ]
        }
    ]
}

const stageClearToCloseDeposit = {
    name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    display_name: STATUS_CLEAR_TO_CLOSE_COMPLETED,
    children: [
        {
            stages: [
                {
                    name: STATUS_BOOKING_COMPLETE,
                    display_name: STATUS_BOOKING_COMPLETE,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_DOCS_IN_EPRINT,
                    display_name: STATUS_DOCS_IN_EPRINT,
                },
                {
                    name: STATUS_DOCUMENTS_SIGNED,
                    display_name: STATUS_DOCUMENTS_SIGNED,
                },
            ]
        }
    ]
}


const stageCreditApprovalDeposit = {
    name: STATUS_CREDIT_APPROVAL,
    display_name: STATUS_CREDIT_APPROVAL,
    order_id: 6,
    children: [
        {
            stages: [
                {
                    name: STATUS_APPROVED,
                    display_name: STATUS_APPROVED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DENIAL_UNDER_REVIEW,
                    display_name: STATUS_DENIAL_UNDER_REVIEW,
                },
                {
                    name: STATUS_APPROVED_NOT_ACCEPTED,
                    display_name: STATUS_APPROVED_NOT_ACCEPTED,
                },
            ]
        }
    ]
}

const stageUntouchedDeposit = {
    name: STATUS_UNTOUCHED,
    display_name: STATUS_UNTOUCHED,
    order_id: 6,
    children: [
        {
            stages: [
                {
                    name: STATUS_SUBMITTED,
                    display_name: STATUS_SUBMITTED,
                },
                {
                    name: STATUS_WITHDRAW,
                    display_name: STATUS_WITHDRAW,
                },
                {
                    name: STATUS_DECLINED,
                    display_name: STATUS_DECLINED,
                },
                {
                    name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                    display_name: STATUS_CLOSED_FOR_INCOMPLETENESS,
                },
            ]
        }
    ]
}


const loStageDepositConfigs = {
    id: '154878745215745754',
    namespace_id: APP_LS_NAMESPACE_ID,
    loan_type: [DEPOSIT_ACCOUNTS],
    sub_loan_types: [
        CONSUMER_ACCOUNT,
        BUSINESS_ACCOUNT
    ],
    roles: [
        SMARTMATCH_TYPE_LOAN_OFFICER,
        SMARTMATCH_TYPE_ADMIN_LOAN_OFFICER,
        USER_ONBOARD_ADMIN

    ],
    stages: [
        stageStartedDeposit,
        stageSubmittedDeposit,
        stageApprovalDeposit,
        stageCreditApprovalDeposit,
        stageDenialUnderReviewDeposit,
        stageUnderReviewDeposit,
        stageRecommendedDeclineDeposit,
        stageRecommendedApprovedDeposit,
        stageApprovedDeposit,
        stageClearToCloseDeposit,
        stageDocSignDeposit,
        stageClosedDeposit,
        stageDeclinedDeposit,
        stageUntouchedDeposit
    ]
} as any;


const applicantStageDepositConfigs = {
    id: '154878745215745754',
    namespace_id: APP_LS_NAMESPACE_ID,
    loan_type: [DEPOSIT_ACCOUNTS],
    sub_loan_types: [CONSUMER_ACCOUNT],
    stages: [
        {
            name: STATUS_APPLICATION_STARTED,
            display_name: STATUS_APPLICATION_STARTED,
            order_id: 1,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_SUBMITTED,
                            display_name: STATUS_SUBMITTED,
                        }
                    ]
                },
            ]
        },
        {
            name: STATUS_SUBMITTED,
            display_name: STATUS_SUBMITTED,
            order_id: 2,
            children: [
                {
                    stages: [
                        {
                            name: STATUS_APPROVED,
                            display_name: STATUS_APPROVED,
                        }
                    ]
                },
            ]
        }
    ],
    roles: [APPLICANT],
} as any

const mkLendsmartApplicantLoanStagesForDeposit = [
    {
      "children": [
        {
          "stages": [
            {
              "name": STATUS_SUBMITTED,
              "display_name": STATUS_SUBMITTED
            },
            {
              "name": STATUS_UNDER_REVIEW,
              "display_name": STATUS_UNDER_REVIEW
            },
            {
              "name": STATUS_APPROVED,
              "display_name": STATUS_ACCOUNT_OPENED
            }
          ]
        }
      ],
      "name": STATUS_APPLICATION_STARTED,
      "display_name": STATUS_APPLICATION_STARTED
    },
    {
      "children": [
        {
          "stages": []
        }
      ],
      "name": STATUS_SUBMITTED,
      "display_name": STATUS_SUBMITTED
    },
    {
      "children": [
        {
          "stages": []
        }
      ],
      "name": STATUS_UNDER_REVIEW,
      "display_name": STATUS_UNDER_REVIEW
    },
    {
      "children": [
        {
          "stages": []
        }
      ],
      "name": STATUS_ACCOUNT_OPENED,
      "display_name": STATUS_APPROVED
    }
  ]
  
const APPLS_DEPOSIT_APPLICANT_LOAN_STAGES_CONFIG = {
    id: '154878745215745754',
    namespace_id: APP_LS_NAMESPACE_ID,
    loan_type: [DEPOSIT_ACCOUNTS],
    sub_loan_types: [BUSINESS_ACCOUNT],
    stages: mkLendsmartApplicantLoanStagesForDeposit,
    roles: [
      APPLICANT
    ],
  };
  

export const depositStatges = [
    loStageDepositConfigs,
    applicantStageDepositConfigs,
    APPLS_DEPOSIT_APPLICANT_LOAN_STAGES_CONFIG
]